module.exports = __webpack_public_path__ + "static/media/assessmentTeam.746d01a5.png";